import { render, staticRenderFns } from "./Step4.vue?vue&type=template&id=1c512d24&scoped=true&lang=pug&"
import script from "./Step4.vue?vue&type=script&lang=js&"
export * from "./Step4.vue?vue&type=script&lang=js&"
import style0 from "../Onboarding.scss?vue&type=style&index=0&id=1c512d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c512d24",
  null
  
)

export default component.exports